export default __webpack_public_path__ + "dim-39d2ab.json";